import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Page from '@/views/Page'
import store from '@/store'
import Meta from 'vue-meta'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/(page)?/:page?',
      name: 'home',
      component: Home
    },
    {
      path: '/sammlung/:category/(page)?/:page?',
      name: 'posts-category',
      component: Home
    },
    {
      path: '/tag/:tag/(page)?/:page?',
      name: 'posts-tag',
      component: Home
    },
    {
      path: '/static/:slug',
      name: 'page',
      component: Page
    },
    {
      path: '/:category/:slug',
      name: 'post',
      component: () => import(/* webpackChunkName: "post" */ './views/Post.vue')
    }
  ],
  scrollBehavior (to, _from, savedPosition) {
    if (savedPosition) return savedPosition

    // nav to content etc
    if (to.fullPath !== '/') {
      const headEl = document.getElementById('header')
      const routeEl = document.getElementById('route')
      const y = routeEl.offsetTop - headEl.clientHeight

      return { x: 0, y }
    }

    return { x: 0, y: 0 }
  }
})

router.beforeEach((_to, from, next) => {
  store.commit('FROM', from)
  next()
})

export default router
